import { render, staticRenderFns } from "./AccountApiTokensTab.vue?vue&type=template&id=ef3bba32&scoped=true&"
import script from "./AccountApiTokensTab.vue?vue&type=script&lang=js&"
export * from "./AccountApiTokensTab.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ef3bba32",
  null
  
)

export default component.exports